const host = (process.env.REACT_APP_API_URL || 'https://darkturquoise-gnat-919384.hostingersite.com').replace(/\/$/, '');

export const API_HOST = host;
export const API_URL = `${host}/api`;

export function authHeaders() {
    const token = localStorage.getItem('token');
    return {
        Accept: 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {})
    };
}
